import { LocationModule } from "@/vuex/modules/locations/locations.index";
import { UserModule } from "@/vuex/modules/user/user.index";
import { Component, Vue } from "vue-property-decorator";
import Template from "./Settings.template.vue";

@Component({
  mixins: [Template]
})
export default class SettingsComponent extends Vue {
  private created() {
    this.$store.registerModule("UserModule", UserModule);
    this.$store.registerModule("LocationModule", LocationModule);
  }

  private beforeDestroy() {
    this.$store.unregisterModule("UserModule");
    this.$store.unregisterModule("LocationModule");
  }
}
